import {POST_CANDIDATES_INTEREST_STATUS,POST_CANDIDATES_INTEREST_STATUS_SUCCESS,POST_CANDIDATES_INTEREST_STATUS_FAILED} from "./actionTypes"


const initialState = {
    loading: false,
     submitData : null,
     errorMessages: null
}

const CandidateInterestReducer = (state = initialState, action) => {
    switch (action.type) {

        case POST_CANDIDATES_INTEREST_STATUS:
            state = {
                ...state,
                loading: true,
                submitData : null,
                errorMessages: null
            }
            break
        case POST_CANDIDATES_INTEREST_STATUS_SUCCESS:
            state = {
                ...state,
                loading: false,
                submitData : action.payload,
                errorMessages: null
            }
            break
        case POST_CANDIDATES_INTEREST_STATUS_FAILED:
            state = {
                ...state,
                loading: false,
                submitData : null,
                errorMessages: action.payload
            }
            break
       
        default:
            state = { ...state }
            break
    }
    return state
}
export default CandidateInterestReducer